import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';

export function parseSkills(value) {
  const seen = new Set();

  return String(value || '')
    .split(/[,\n]/)
    .map((skill) => skill.trim().replace(/\s+/g, ' '))
    .filter((skill) => {
      const key = skill.toLocaleLowerCase();

      if (!skill || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
}

export default class ProfileDetailsModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    const user = this.attrs.user;
    this.about = Stream(user.attribute('pakt21About') || '');
    this.location = Stream(user.attribute('pakt21Location') || '');
    this.contribution = Stream(user.attribute('pakt21Contribution') || '');
    this.needs = Stream(user.attribute('pakt21Needs') || '');
    this.skills = Stream((user.attribute('pakt21Skills') || []).join(', '));
  }

  className() {
    return 'Pakt21ProfileModal Modal--small';
  }

  title() {
    return app.translator.trans('pakt21-beta.forum.profile_form.title');
  }

  content() {
    const skills = parseSkills(this.skills());

    return (
      <div className="Modal-body">
        <form className="Form" onsubmit={(event) => this.onsubmit(event)}>
          <div className="Form-group">
            <label for="pakt21-profile-about">{app.translator.trans('pakt21-beta.forum.profile_form.about_label')}</label>
            <textarea
              id="pakt21-profile-about"
              className="FormControl"
              rows="4"
              maxlength="500"
              placeholder={app.translator.trans('pakt21-beta.forum.profile_form.about_placeholder')}
              bidi={this.about}
            />
            <p className="helpText Pakt21ProfileModal-counter">{this.about().length}/500</p>
          </div>

          <div className="Form-group">
            <label for="pakt21-profile-contribution">{app.translator.trans('pakt21-beta.forum.profile_form.contribution_label')}</label>
            <textarea
              id="pakt21-profile-contribution"
              className="FormControl"
              rows="5"
              maxlength="1000"
              placeholder={app.translator.trans('pakt21-beta.forum.profile_form.contribution_placeholder')}
              bidi={this.contribution}
            />
            <p className="helpText Pakt21ProfileModal-counter">{this.contribution().length}/1000</p>
          </div>

          <div className="Form-group">
            <label for="pakt21-profile-location">{app.translator.trans('pakt21-beta.forum.profile_form.location_label')}</label>
            <input
              id="pakt21-profile-location"
              className="FormControl"
              type="text"
              maxlength="100"
              placeholder={app.translator.trans('pakt21-beta.forum.profile_form.location_placeholder')}
              bidi={this.location}
            />
            <p className="helpText">{app.translator.trans('pakt21-beta.forum.profile_form.location_help')}</p>
          </div>

          <div className="Form-group">
            <label for="pakt21-profile-needs">{app.translator.trans('pakt21-beta.forum.profile_form.needs_label')}</label>
            <textarea
              id="pakt21-profile-needs"
              className="FormControl"
              rows="5"
              maxlength="1000"
              placeholder={app.translator.trans('pakt21-beta.forum.profile_form.needs_placeholder')}
              bidi={this.needs}
            />
            <p className="helpText Pakt21ProfileModal-counter">{this.needs().length}/1000</p>
          </div>

          <div className="Form-group">
            <label for="pakt21-profile-skills">{app.translator.trans('pakt21-beta.forum.profile_form.skills_label')}</label>
            <textarea
              id="pakt21-profile-skills"
              className="FormControl"
              rows="3"
              placeholder={app.translator.trans('pakt21-beta.forum.profile_form.skills_placeholder')}
              bidi={this.skills}
            />
            <p className={`helpText ${skills.length > 10 ? 'Pakt21ProfileModal-error' : ''}`}>
              {app.translator.trans('pakt21-beta.forum.profile_form.skills_help', { count: skills.length })}
            </p>
          </div>

          <div className="Form-group">
            <Button
              className="Button Button--primary"
              type="submit"
              loading={this.loading}
              disabled={skills.length > 10 || skills.some((skill) => skill.length < 2 || skill.length > 40)}
            >
              {app.translator.trans('pakt21-beta.forum.profile_form.submit')}
            </Button>
          </div>
        </form>
      </div>
    );
  }

  onsubmit(event) {
    event.preventDefault();
    this.loading = true;

    this.attrs.user
      .save(
        {
          pakt21About: this.about().trim() || null,
          pakt21Contribution: this.contribution().trim() || null,
          pakt21Needs: this.needs().trim() || null,
          pakt21Location: this.location().trim() || null,
          pakt21Skills: parseSkills(this.skills()),
        },
        { errorHandler: this.onerror.bind(this) }
      )
      .then(() => this.hide())
      .catch(() => {
        this.loading = false;
        m.redraw();
      });
  }
}
